import { createContext, PropsWithChildren, useRef } from 'react'
import { createStore } from 'zustand'

import { WPPageData } from '@/types'

export type SchemaProps = {
  schema?: WPPageData['breadcrumbs']
}

export type SchemaStore = ReturnType<typeof createAppStore>

const createAppStore = (initProps?: Partial<SchemaProps>) => {
  return createStore<SchemaProps>()(() => ({ ...initProps }))
}

export const SchemaContext = createContext<SchemaStore | null>(null)

function SchemaProvider({ children, ...props }: PropsWithChildren<SchemaProps>) {
  const storeRef = useRef<SchemaStore>(null)

  if (!storeRef.current) {
    storeRef.current = createAppStore(props)
  }

  return <SchemaContext.Provider value={storeRef.current}>{children}</SchemaContext.Provider>
}

export const getTitleFromSchema = (schema?: WPPageData['breadcrumbs']) => {
  return schema?.[schema.length - 1]?.title
}

export default SchemaProvider
